import { render } from "./GetAccquintedOne.vue?vue&type=template&id=d45b7768&scoped=true"
const script = {}

import "./GetAccquintedOne.vue?vue&type=style&index=0&id=d45b7768&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d45b7768"]])

export default __exports__